import { useReactiveVar } from '@apollo/client';

import { isLoggedInVar } from '../../lib/apollo/cache';

export const useLoggedIn = (): any => {
    const isLoggedIn = useReactiveVar(isLoggedInVar);

    return isLoggedIn;
};
